import { Skeleton } from '@/components/ui/skeleton';

function SkeletonRow() {
  return (
    <div className="flex items-center h-14 px-6 border-b border-table-row-border">
      {/* Checkbox */}
      <div className="flex items-center justify-center w-10">
        <Skeleton className="h-4 w-4 rounded" />
      </div>

      {/* Name + avatar */}
      <div className="flex-1 min-w-0 flex items-center gap-3">
        <Skeleton className="h-9 w-9 rounded-full shrink-0" />
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-3 w-16" />
        </div>
      </div>

      {/* Source */}
      <div className="w-[110px] pr-4">
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>

      {/* Type */}
      <div className="w-[100px] pr-4">
        <Skeleton className="h-5 w-14 rounded-full" />
      </div>

      {/* Temp */}
      <div className="w-[88px] pr-4">
        <Skeleton className="h-5 w-12 rounded-full" />
      </div>

      {/* Stage */}
      <div className="w-[140px] pr-4">
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>

      {/* Last Contact */}
      <div className="w-[100px]">
        <Skeleton className="h-4 w-16" />
      </div>

      {/* Actions */}
      <div className="w-20" />
    </div>
  );
}

export function LeadTableSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <SkeletonRow key={i} />
      ))}
    </>
  );
}
